import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=e18bd606&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=e18bd606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18bd606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e18bd606')) {
      api.createRecord('e18bd606', component.options)
    } else {
      api.reload('e18bd606', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=e18bd606&scoped=true&", function () {
      api.rerender('e18bd606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/canned/Index.vue"
export default component.exports